<form [formGroup]="form" class="py-5">
  <h5 class="fw-bolder mb-5">
    <span>Catatan Perbaikan</span>
  </h5>
  <!--  <pre>form value: {{ form.value | json   }}</pre>-->
  <app-input-text [textArea]="true" [columnStacked]="true" [formControlName]="'note'" placeholder="Silahkan masukan catatan perbaikan" ngDefaultControl />
</form>
